//import { AuthContext } from '@@/modules/global/common/contexts/AuthContext';
import { useContext, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import UnauthorizedPage from '@@/products/portal/pages/unauthorized-access-page';
import { Box, Spinner } from '@cloudscape-design/components';
import { determineUserPermissions } from '@@/lib/permissions';
import { AuthContext } from '@@/contexts/AuthContext';
import casesPermissionMapping, { CasesPermission } from '../common/permission-mapping';

const CasesAuthorizer = () => {
  const { instanceData, loading, error } = useContext(AuthContext);
  const { pathname } = useLocation();

  const userPermissions = useMemo(() => {
    if (!instanceData) return new Set<CasesPermission>();
    const perms = determineUserPermissions(instanceData.permissions, pathname, casesPermissionMapping);
    return perms;
  }, [instanceData, pathname]);

  if (loading) {
    return (
      <Box padding='xxl' textAlign='center'>
        <Spinner size='large' />
      </Box>
    );
  }

  if (error) {
    return <div aria-label={'API Error'}>API Error: {error.toString()}</div>;
  }

  if (userPermissions && userPermissions.size > 0) {
    return <Outlet context={{ permissions: userPermissions }} />;
  }

  return <UnauthorizedPage />;
};

export default CasesAuthorizer;
